<template>
    <div>
        <div v-if="dataRows && dataRows.length > 0">
            <div class="divide-y divide-gray-100">
                <div v-for="row in dataRows" :key="row.id"
                    class="px-4 py-3 cursor-pointer transition-colors flex items-center"
                    :class="isSelected(row.id) ? 'bg-gray-100' : 'hover:bg-gray-50'"
                    @click="$emit('open:item', $event, row)">

                    <!-- Avatar do Agente (se tiver) -->
                    <div v-if="row?.agents?.id" class="flex items-center gap-1.5 flex-shrink-0 mr-3">
                        <Avatar :avatar="row.agents.avatar" size="xs" />
                        <span class="text-gray-300 text-xs">→</span>
                    </div>

                    <!-- Avatar do Contato -->
                    <div class="flex-shrink-0 relative mr-3">
                        <Avatar :avatar="row.avatar" size="md" />
                        <!-- Origin indicator -->
                        <div v-if="row.origin" class="absolute -bottom-0.5 -right-0.5">
                            <div class="w-3 h-3 rounded-full border-2 border-white"
                                :class="getOriginColor(row.origin)">
                            </div>
                        </div>
                    </div>

                    <!-- Informações do Contato -->
                    <div class="flex-1 min-w-0">
                        <p class="text-sm font-medium text-gray-800 truncate">
                            {{ row.is_anonymous ? 'Visitante anônimo' : (row.name || 'Sem nome') }}
                        </p>
                        <p class="text-xs text-gray-500 truncate">
                            <template v-if="row.is_anonymous">Visitante #{{ shortId(row) }}</template>
                            <template v-else>{{ row.phone ? formatPhone(row.phone) : row.email || '' }}</template>
                        </p>
                        <!-- Tags -->
                        <div v-if="row.tags && row.tags.length > 0" class="flex flex-wrap gap-1 mt-1">
                            <span
                                v-for="tag in row.tags.slice(0, 3)"
                                :key="tag.id"
                                class="inline-flex items-center px-1.5 py-0.5 rounded text-[9px] font-medium"
                                :style="{ backgroundColor: tag.color + '20', color: tag.color }">
                                {{ tag.name }}
                            </span>
                            <span v-if="row.tags.length > 3" class="text-[9px] text-gray-400">
                                +{{ row.tags.length - 3 }}
                            </span>
                        </div>
                    </div>

                    <!-- Data e Seta -->
                    <div class="flex-shrink-0 ml-3 flex items-center gap-2">
                        <span class="text-[11px] text-gray-400">{{ formatDateFull(row.updated_at) }}</span>
                        <ChevronRightIcon class="w-4 h-4 text-gray-300" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Estado vazio -->
        <div v-else class="py-12 text-center">
            <p class="text-sm text-gray-400">Nenhum contato encontrado</p>
            <p class="text-xs text-gray-300 mt-1">Tente ajustar os filtros</p>
        </div>
    </div>
</template>

<script>
import { ChevronRightIcon } from '@heroicons/vue/24/outline'

export default {
    name: "ListContacts",
    components: {
        ChevronRightIcon
    },
    props: {
        dataRows: {
            type: Array,
            required: false,
            default: () => []
        },
        selected: {
            type: Array,
            required: false,
            default: () => []
        },
    },
    emits: ['open:item'],
    methods: {
        isSelected(id) {
            return this.selected.includes(id);
        },
        getOriginColor(origin) {
            const colors = {
                'whatsapp': 'bg-green-500',
                'whatsapp_web': 'bg-green-500',
                'whatsapp_api': 'bg-green-600',
                'instagram': 'bg-pink-500',
                'messenger': 'bg-blue-500',
                'telegram': 'bg-sky-500',
                'widget': 'bg-purple-500',
                'email': 'bg-gray-500',
                'tryon': 'bg-pink-700',
            };
            return colors[origin] || 'bg-gray-400';
        },
        // Visitante anônimo não tem nome nem telefone: identifica pelo começo do id do navegador
        shortId(row) {
            return String(row.external_id || row.id || '').substring(0, 8);
        },
        formatPhone(phone) {
            if (!phone) return '';
            phone = phone.replace('@s.whatsapp.net', '').replace('@c.us', '');
            if (phone.length === 13 && phone.startsWith('55')) {
                phone = phone.substring(2);
            }
            if (phone.length === 11) {
                return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
            }
            if (phone.length === 10) {
                return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
            }
            return phone;
        },
        formatDateFull(date) {
            if (!date) return '';
            const d = new Date(date);
            return d.toLocaleDateString('pt-BR', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        },
    },
}
</script>
